import React from 'react'
import useSEO from "./useSEO";

const Internalandexternalauditing = () => {
useSEO({
  title: "Internal and External Auditing | Internal and External Auditing Services in Hyderabad | Audit Experts Hyderabad",
  description: "Enhance transparency and compliance with our professional internal and external auditing services in Hyderabad. We provide detailed audits, risk assessments, and actionable insights to ensure accuracy, efficiency, and regulatory compliance.",
  keywords: "internal auditing services, external auditing services, audit firms in Hyderabad, compliance audit, financial audit, risk assessment services, statutory audit, operational audit experts",
  ogTitle: "Internal and External Auditing - Trusted Hyderabad Experts",
  ogDescription: "Accurate, compliant, and reliable internal and external auditing services in Hyderabad.",
  ogImage: "img/internal-and-external-auditing2.png",
  twitterTitle: "Internal and External Auditing - Trusted Hyderabad Experts",
  twitterDescription: "Professional audits, detailed insights, and compliance assurance — trusted internal and external auditing in Hyderabad.",
  twitterImage: "img/internal-and-external-auditing2.png"
});
  return (
    <div>

       
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Internal and External Auditing </h1>
          <p className="mb-4">
            We offer comprehensive Internal and External Auditing services to
            ensure your organization meets the highest standards of compliance,
            risk management, and operational efficiency.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/internal-and-external-auditing1.png" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img src="img/internal-and-external-auditing.png" alt="" />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4">Internal Auditing</h2>
          <p>
            Our Internal Audit services focus on evaluating and improving the
            effectiveness of your internal controls and risk management systems.
            Let us handle it.{" "}
          </p>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <p>
                <b>We provide:</b>
              </p>
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" /> Audit
                  planning and execution
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />
                  Operational and compliance audits
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />
                  Internal control assessments
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />
                  Bank audit{" "}
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />
                  Bookkeeping audit{" "}
                </li>
              </ul>
            </div>
          </div>
          <p>
            By working closely with your internal teams, we help you identify
            vulnerabilities, optimize processes, and strengthen your internal
            systems.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4">External Auditing </h1>
          <p>
            Our External Audit services provide an independent, objective
            assessment of your financial statements and ensure compliance with
            regulatory and statutory requirements. We offer:
          </p>
          <div className="d-sm-flex align-items-center">
            <ul className="list-group list-group-borderless mb-3">
              <li className="list-group-item heading-color d-flex pb-0">
                <i className="bi bi-patch-check-fill me-2" />
                Statutory and financial statement audits
              </li>
              <li className="list-group-item heading-color d-flex pb-0">
                <i className="bi bi-patch-check-fill me-2" />
                Regulatory and tax audits
              </li>
              <li className="list-group-item heading-color d-flex pb-0">
                <i className="bi bi-patch-check-fill me-2" />
                Third-party assurance and certifications
              </li>
              <li className="list-group-item heading-color d-flex pb-0">
                <i className="bi bi-patch-check-fill me-2" />
                Transparency for stakeholders and investors
              </li>
            </ul>
          </div>
          <p>
            We maintain strict independence and use proven audit methodologies
            to deliver reliable, transparent, and timely audit reports that
            enhance stakeholder confidence.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/internal-and-external-auditing2.png" alt="" />
        </div>
      </div>
    </div>
  </section>
 

      
    </div>
  )
}

export default Internalandexternalauditing
